import { c as _c } from "react/compiler-runtime";
import { LanguageFlagDropdown } from '@/components/ui/LanguageFlagDropdown';
import config from '@/config';
import { useI18n } from '@/context/I18nProvider';
import Image from 'next/image';
import { ReactNode } from 'react';
type AuthLeftPanelProps = {
  children: ReactNode;
  maxWidth?: string;
  subHeader?: ReactNode;
};
export const AuthLeftPanel = t0 => {
  const $ = _c(28);
  const {
    children,
    maxWidth: t1,
    subHeader
  } = t0;
  const maxWidth = t1 === undefined ? "max-w-md" : t1;
  const {
    t
  } = useI18n();
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="absolute top-4 left-4 sm:top-6 sm:left-6 z-20"><div className="flex items-center gap-2.5"><Image src="/images/orsay-mark.svg" alt="Orsay" width={40} height={40} className="h-10 w-10 sm:h-12 sm:w-12" priority={true} /><span className="font-serif text-[22px] font-medium tracking-tight text-op-ink">Orsay</span></div></div>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="absolute top-4 right-4 z-20"><LanguageFlagDropdown chevronPosition="responsive" dropdownAlign="end" /></div>;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== maxWidth || $[3] !== subHeader) {
    t4 = subHeader && <div className="shrink-0 w-full flex justify-center px-6 pt-6 sm:px-8"><div className={`w-full ${maxWidth} min-w-0 auth-fade-up`}>{subHeader}</div></div>;
    $[2] = maxWidth;
    $[3] = subHeader;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = `flex-1 min-h-0 w-full flex flex-col items-center px-6 sm:px-8 ${subHeader ? "" : "overflow-y-auto overflow-x-hidden"}`;
  let t6;
  if ($[5] !== children || $[6] !== maxWidth || $[7] !== subHeader) {
    t6 = subHeader ? <div className={`w-full ${maxWidth} min-w-0 flex-1 min-h-0 flex flex-col py-6 auth-fade-up`}>{children}</div> : <><div className="flex-1" /><div className={`w-full ${maxWidth} min-w-0 py-6 auth-fade-up`}>{children}</div><div className="flex-1" /></>;
    $[5] = children;
    $[6] = maxWidth;
    $[7] = subHeader;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = <div className={t5}>{t6}</div>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t) {
    t8 = t("auth.privacyPolicy");
    $[12] = t;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t8) {
    t9 = <a href={config.metadata.privacyPolicy} target="_blank" rel="noopener noreferrer" className="hover:underline">{t8}</a>;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <span>·</span>;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t) {
    t11 = t("auth.termsOfService");
    $[17] = t;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11) {
    t12 = <a href={config.metadata.termsOfService} target="_blank" rel="noopener noreferrer" className="hover:underline">{t11}</a>;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t12 || $[22] !== t9) {
    t13 = <div className="shrink-0 w-full pb-4 flex justify-center gap-3 text-xs text-muted-foreground">{t9}{t10}{t12}</div>;
    $[21] = t12;
    $[22] = t9;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t13 || $[25] !== t4 || $[26] !== t7) {
    t14 = <div className="flex flex-[3] flex-col overflow-hidden bg-white relative">{t2}{t3}{t4}{t7}{t13}</div>;
    $[24] = t13;
    $[25] = t4;
    $[26] = t7;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  return t14;
};